export interface IncidentsStoreState {
	activeIncidents?: Incident[];
	openIncidents: Incident[];
}

export interface PaginatedIncidents {
	incidents: Incident[];
	pagination: PaginationInfo;
}

export interface PaginationInfo {
	total: number;
	previous: number | null;
	next: number | null;
	current: number;
	pages: number;
}

export interface IncidentParams {
	limit?: number;
	offset?: number;
	incidentId?: string;
	status?: string;
	fromDate?: string;
	toDate?: string;
	q?: string;
	alertId?: string;
}

export interface Incident {
	id: string;
	name: string;
	sequence: number;
}

export interface User {
	name: string;
}
